import React from 'react';
import { AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import { Brightness4, Brightness7, Logout, Chat as ChatIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { API_URL } from "../lib/utils";

const NavigationBar = ({ colorMode, theme }) => {
    const navigate = useNavigate();

    return (
        <AppBar position="static">
            <Toolbar>
                <Typography 
                    variant="h6" 
                    component="div" 
                    sx={{ 
                        flexGrow: 1, 
                        cursor: 'pointer',
                        '&:hover': {
                            opacity: 0.8
                        }
                    }}
                    onClick={() => navigate('/')}
                >
                    Smart Transcriber
                </Typography>
                <IconButton sx={{ ml: 1 }} onClick={colorMode?.toggleColorMode} color="inherit">
                    {theme.palette.mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
                </IconButton>
                <IconButton 
                    color="inherit"
                    onClick={() => navigate('/chat')}
                    sx={{ mr: 1 }}
                >
                    <ChatIcon />
                </IconButton>
                <IconButton
                    color="inherit"
                    href={`${API_URL}/auth/logout`}
                    aria-label="logout"
                >
                    <Logout />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};

export default NavigationBar;
